import {TranslationsLanguage} from "./TranslationsLanguage";
import EnglishTranslations from "../translations/EnglishTranslations.json";
import ChineseTranslations from "../translations/ChineseTranslations.json";

/** @ngInject */
export default function($translateProvider: any) {
    $translateProvider.translations(TranslationsLanguage.English, EnglishTranslations)
                      .translations(TranslationsLanguage.Chinese, ChineseTranslations);
}
